import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import '../../index.scss';
import { fetchCatalogLots, fetchSaleInfo } from '../../modules/bulkBidding/index';
import { CLEAR_BULK_BIDDING_DATA } from '../../modules/bulkBidding/bulkBidding';
import { myAuctionPath } from '../../utilities/UrlPaths';

import Page from '../Page';

import Header from './Header';
import CatalogView from './CatalogView';
import { useMemoizedSearchFilter } from './hooks/useMemoizedSearchFilter';
import { BACK_TO_AUCTION_SALES, SEARCH_LOT_FIELDS } from './constants';

function BulkBidding() {
  const { catalogRef } = useParams();
  const dispatch = useDispatch();
  const [lotsSearchString, setCatalogLotsSearchString] = useState('');

  const { catalogLots, saleInfo: { lotCount } } = useSelector(state => state.bulkBidding);

  const filteredBidAdminLots = useMemoizedSearchFilter(catalogLots, lotsSearchString, SEARCH_LOT_FIELDS);

  useEffect(() => {
    dispatch(fetchSaleInfo(catalogRef));

    return () => {
      dispatch({ type: CLEAR_BULK_BIDDING_DATA });
    };
  }, [catalogRef]);

  useEffect(() => {
    if (lotCount) {
      dispatch(fetchCatalogLots(catalogRef, lotCount));
    }
  }, [lotCount]);

  const handleSearchStringChange = searchString => setCatalogLotsSearchString(searchString);

  return (
    <Page
      header={{ title: '' }}
      navLink={{
        displayName: BACK_TO_AUCTION_SALES,
        href: myAuctionPath
      }}
    >
      <ToastContainer draggable={false} autoClose={false} closeButton={false} />
      <Container className="p-0 bulk-bidding-wrapper">
        <Header onSearchStringChange={handleSearchStringChange} />
        <CatalogView data={filteredBidAdminLots} />
      </Container>
    </Page>
  );
}

export default BulkBidding;
